// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from 'react'
// import PropTypes from 'prop-types'
import { css } from 'glamor'
// import classNames from 'classnames'
import noop from 'lodash/noop'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Img from 'gatsby-image'
import HoverIntent from 'react-hoverintent'

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
const styleX = css({
  position: 'relative',

  '& .overlay': {
    background: 'rgba(0,0,0,0.7)',
    position: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    opacity: 0,
    transition: 'all 0.4s ease-in-out 0s',
  },

  '& .content': {
    position: 'absolute',
    textAlign: 'center',
    paddingLeft: '1em',
    paddingRight: '1em',
    width: '100%',
    top: '50%',
    left: '50%',
    opacity: 0,
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.3s ease-in-out 0s',

    '& .heading': {
      color: '#fff',
    },

    '& .text': {
      color: '#fff',
    },
  },

  '&:hover': {
    '& .overlay': {
      opacity: 1,
    },

    '& .content': {
      top: '50%',
      left: '50%',
      opacity: 1,
    },
  },

  '& .animated-bottom': {
    top: '80%',
  },

  '& .animated-top': {
    top: '20%',
  },

  '& .animated-left': {
    left: '20%',
  },

  '& .animated-right': {
    left: '80%',
  },
}).toString()

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** InteractiveImage */
const InteractiveImage = ({
  className: givenClassName,
  containerStyle = {},
  imgStyle = {},
  style,
  rawWidth = 1440,
  rawHeight = 900,
  src,
  alt,
  loader,
  gradientPreset,
  onClick,
  ratio = rawHeight / rawWidth,
  heading = false,
  text = false,
  animation = 'bottom',
  overlayStyle = {},
  contentStyle = {},
  setActive,
  index,
  data,
}) => {
  return (
    <div className={styleX} style={{ ...style }}>
      <HoverIntent
        onMouseOver={() => {
          setActive(index)
        }}
        onFocus={() => {
          setActive(index)
        }}
        onMouseOut={() => noop()}
        onBlur={() => {
          noop()
        }}
        sensitivity={10}
        interval={300}
        timeout={250}
      >
        <div>
          <div className="overlay" style={{ ...overlayStyle }} />
          <Img fluid={data.childImageSharp.fluid} />
          <div
            className={`content animated-${animation}`}
            style={{ ...contentStyle }}
          >
            {heading !== false && <div className="heading">{heading}</div>}
            {text !== false && <div className="text">{text}</div>}
          </div>
        </div>
      </HoverIntent>
    </div>
  )
}

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
export default InteractiveImage
